export const queryKeys = {
  currentUser: ["current-user"] as const,
  myCommunities: ["my-communities"] as const,
  communities: ["communities"] as const,
  community: (slug: string) => ["community", slug] as const,
  communityMembers: (communityId: string) =>
    ["community-members", communityId] as const,
  communityInviteCandidates: (search: string) =>
    ["community-invite-candidates", search] as const,
  communityFeed: (communityId: string) =>
    ["community-feed", communityId] as const,
  feed: ["feed"] as const,
  filteredFeed: (filter: string) => ["feed", filter] as const,
  homeUnseenPosts: ["home-unseen-posts"] as const,
  savedPosts: ["saved-posts"] as const,
  comments: (postId: string) => ["comments", postId] as const,
  platformSearch: (query: string) => ["platform-search", query] as const,
  serviceCategories: ["service-categories"] as const,
  catalogServices: ["catalog-services"] as const,
  catalogService: (slug: string) => ["catalog-service", slug] as const,
  myPractices: ["my-practices"] as const,
  practice: (id: string) => ["practice", id] as const,
  practiceMembers: (id: string) => ["practice-members", id] as const,
  practiceServices: (id: string) => ["practice-services", id] as const,
  practiceSearch: (query: string) => ["practice-search", query] as const,
  practiceInviteCandidates: (practiceId: string, query: string) =>
    ["practice-invite-candidates", practiceId, query] as const,
  profilePractices: (userId: string) => ["profile-practices", userId] as const,
  publicProfile: (userId: string) => ["public-profile", userId] as const,
  myProfile: ["my-profile"] as const,
  adminPractices: ["admin-practices"] as const,
  adminPractice: (id: string) => ["admin-practice", id] as const,
  serviceRequests: ["service-requests"] as const,
  adminAccess: ["admin-access"] as const,
  adminLeads: ["admin-leads"] as const,
  adminLead: (leadId: string) => ["admin-lead", leadId] as const,
  adminAssignees: ["admin-assignees"] as const,
  servicePartners: (serviceId: string) =>
    ["service-partners", serviceId] as const,
  chatConversations: ["chat-conversations"] as const,
  chatMessages: (conversationId: string) =>
    ["chat-messages", conversationId] as const,
  chatUserSearch: (search: string) => ["chat-user-search", search] as const,
  notifications: ["notifications"] as const,
  notificationList: (filter: string) => ["notifications", "list", filter] as const,
  notificationPreview: ["notifications", "preview"] as const,
  notificationUnreadCount: ["notifications", "unread-count"] as const,
  notificationPreferences: ["notifications", "preferences"] as const,
  events: ["events"] as const,
  upcomingEvents: (filters: unknown) => ["events", "upcoming", filters] as const,
  pastEvents: (filters: unknown) => ["events", "past", filters] as const,
  myEvents: ["events", "mine"] as const,
  event: (slug: string) => ["events", "detail", slug] as const,
  eventById: (id: string) => ["events", "id", id] as const,
  eventAttendees: (eventId: string) => ["events", "attendees", eventId] as const,
  communityEvents: (communityId: string) =>
    ["events", "community", communityId] as const,
  canCreateEvents: ["events", "can-create"] as const,
  adminEvents: ["events", "admin"] as const,
  adminDashboard: ["admin-dashboard"] as const,
  adminActivitySeries: (days: number) =>
    ["admin-activity-series", days] as const,
  adminUsers: ["admin-users"] as const,
  adminPosts: ["admin-posts"] as const,
  adminConversations: ["admin-conversations"] as const,
  adminConversation: (id: string) => ["admin-conversation", id] as const,
  adminConversationMessages: (id: string) =>
    ["admin-conversation-messages", id] as const,
  adminAuditLogs: ["admin-audit-logs"] as const,
  adminFeedAds: ["admin-feed-ads"] as const,
  adminFeedAd: (id: string) => ["admin-feed-ad", id] as const,
  adminFeedAdSettings: ["admin-feed-ad-settings"] as const,
  feedAdsHome: ["feed-ads", "home"] as const,
  feedAdsCommunity: (communityId: string) =>
    ["feed-ads", "community", communityId] as const,
  adminNotificationBroadcasts: ["admin-notification-broadcasts"] as const,
  adminCommunities: ["admin-communities"] as const,
  adminServicesCatalog: ["admin-services-catalog"] as const,
  adminService: (id: string) => ["admin-service", id] as const,
  adminServiceOptions: ["admin-service-options"] as const,
  adminReportsQueue: ["admin-reports-queue"] as const,
  myOffers: ["my-offers"] as const,
  myOffer: (id: string) => ["my-offer", id] as const,
  adminOffers: ["admin-offers"] as const,
  adminOffer: (id: string) => ["admin-offer", id] as const,
  myCustomers: ["my-customers"] as const,
  myCustomer: (id: string) => ["my-customer", id] as const,
  adminCustomers: ["admin-customers"] as const,
  adminCustomer: (id: string) => ["admin-customer", id] as const,
  sidebarBanner: ["sidebar-banner"] as const,
  adminSidebarBanner: ["admin-sidebar-banner"] as const,
  publicLandingPage: (slug: string) => ["landing-page", "public", slug] as const,
  adminLandingPage: (slug: string) => ["landing-page", "admin", slug] as const,
  adminSiteMetadata: ["site-metadata", "admin"] as const,
};
